import { AutoComplete } from "rsuite";

interface Props {
  availableUsers: any;
  email: string;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  placeholder?: string;
}

export default function AutoCompleteInput({
  availableUsers,
  email,
  setEmail,
  placeholder,
}: Props) {
  return (
    <AutoComplete
      data={availableUsers}
      onChange={(value) => setEmail(value)}
      placeholder={placeholder || "Search for users"}
      value={email}
      size={"md"}
      className="pr-2"
      style={{ width: "100%" }}
      renderMenuItem={(label: any) => {
        const email = label?.props?.children?.[1];
        const name = label?.props?.children?.[0];

        return (
          <div className="px-1" style={{ fontSize: 14, cursor: "pointer" }}>
            <div className="d-flex align-items-center">
              <i className="mdi mdi-account pr-1" style={{ fontSize: 18 }} />
              <h5 className="m-0 p-0">{name}</h5>

              {!name && (
                <small className="m-0 p-0 text-primary ml-2">pending</small>
              )}
            </div>
            <small className="pl-1">{email ? email : ""}</small>
          </div>
        );
      }}
    />
  );
}
